import React from 'react';

import { MicroApp } from '@lumapps/micro-apps/components/MicroApp';

import { ACTIONABLE_ITEM_TYPES, ActionableItemPayload } from '../../types';
import { AskAiDirectoryEntryCard } from './AskAiDirectroyEntryCard/AskAiDirectoryEntryCard';
import { AskAiImagesMosaic } from './AskAiImagesMosaic/AskAiImagesMosaic';
import { AskAiUserCard } from './AskAiUserCard/AskAiUserCard';

import './index.scss';

export interface AskAiCardContentProps {
    /* Callback called when the card is loaded. */
    setIsLoaded?: (isLoaded: boolean) => void;
    className?: string;
    actionableItem?: ActionableItemPayload;
    query: string;
}

/**
 * Display the given micro app or adaptive card.
 * Designed to be included within the `AskAi` answer.
 */
export const AskAiCardContent: React.FC<AskAiCardContentProps> = ({
    className,
    actionableItem,
    setIsLoaded,
    query,
}) => {
    if (actionableItem?.type === ACTIONABLE_ITEM_TYPES.USER_CARD) {
        return <AskAiUserCard className={className} user={actionableItem.payload} />;
    }

    if (actionableItem?.type === ACTIONABLE_ITEM_TYPES.MICRO_APP) {
        return (
            <MicroApp
                setIsLoaded={setIsLoaded}
                className={className}
                id={actionableItem.payload.id}
                inputVariables={{ query }}
            />
        );
    }

    if (actionableItem?.type === ACTIONABLE_ITEM_TYPES.IMAGES) {
        return <AskAiImagesMosaic images={actionableItem.payload.images} />;
    }

    if (actionableItem?.type === ACTIONABLE_ITEM_TYPES.DIRECTORY_ENTRY) {
        return <AskAiDirectoryEntryCard directoryEntry={actionableItem.payload} className={className} />;
    }

    return null;
};
